export default {
  NOTIFICATION_MGMT_LIST_REQUEST: 'APP/NOTIFICATION_MGMT/NOTIFICATION_MGMT_LIST_REQUEST',
  NOTIFICATION_MGMT_LIST_SUCCESS: 'APP/NOTIFICATION_MGMT/NOTIFICATION_MGMT_LIST_SUCCESS',
  NOTIFICATION_MGMT_LIST_ERROR: 'APP/NOTIFICATION_MGMT/NOTIFICATION_MGMT_LIST_ERROR',
};
